"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zubehoer = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const Article_1 = require("../Article");
const echain_product_models_1 = require("@igus/echain-product-models");
class Zubehoer extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Zubehoer';
    }
    static fromScratch() {
        return new Zubehoer({
            ArticleType: echain_product_models_1.ArticleType.zubehoer,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
    }
    static fromModel(model) {
        const zubehoer = Zubehoer.fromScratch();
        Object.assign(zubehoer.model, model);
        Object.assign(model, zubehoer.model);
        zubehoer.model = model;
        return zubehoer;
    }
    clone() {
        return this._clone(Zubehoer.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
}
exports.Zubehoer = Zubehoer;
//# sourceMappingURL=Zubehoer.js.map